"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var Text_1 = __importDefault(require("shared/components/Text"));
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var constants_1 = require("./constants");
var context_1 = require("./context");
var tableConf_1 = require("./tableConf");
var Row = (0, RowMaker_1.default)(tableConf_1.rechargesTableConf);
// const isSelected = Math.floor(Math.random() * 50) < 15;
var CHARGES_PER_PAGE = 50;
var RechargesTableBody = function (_a) {
    var sortedRecharges = _a.sortedRecharges, filterKey = _a.filterKey;
    var _b = (0, context_1.useSelectedRecharges)(), selectedIds = _b.selectedIds, selectedItems = _b.selectedItems;
    var _c = __read((0, useInfiniteScroll_1.default)(sortedRecharges || [], CHARGES_PER_PAGE), 3), pagedRecharges = _c[0], loaderRef = _c[1], loaderRef2 = _c[2];
    var pagingSlicePoint = pagedRecharges.length - (sortedRecharges.length > CHARGES_PER_PAGE ? Math.floor(CHARGES_PER_PAGE / 2) : 1);
    return ((0, jsx_runtime_1.jsx)(TableBody_1.default, __assign({ width: "fit-content" }, { children: !sortedRecharges.length
            ? (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", textAlign: "center", p: 4, pl: 6 }, { children: "No charges found" }))
            : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [pagedRecharges.slice(0, pagingSlicePoint).map(function (recharge) { return ((0, jsx_runtime_1.jsx)(Row, { item: recharge, hoverable: true, selected: selectedIds.includes(recharge.id), disabled: !!selectedItems.length
                            && (!selectedItems[0].isExcluded !== !recharge.isExcluded
                                || constants_1.NON_ACTIONABLE_STATES.includes(recharge.rechargerStatus)), markRemoved: recharge.isExcluded && filterKey !== 'excluded', highlightInputs: true }, recharge.id)); }), (0, jsx_runtime_1.jsx)("div", { ref: loaderRef }), pagedRecharges.slice(pagingSlicePoint).map(function (recharge) { return ((0, jsx_runtime_1.jsx)(Row, { item: recharge, hoverable: true, selected: selectedIds.includes(recharge.id), disabled: !!selectedItems.length
                            && (!selectedItems[0].isExcluded !== !recharge.isExcluded
                                || constants_1.NON_ACTIONABLE_STATES.includes(recharge.rechargerStatus)), markRemoved: recharge.isExcluded && filterKey !== 'excluded', highlightInputs: true }, recharge.id)); }), (0, jsx_runtime_1.jsx)("div", { ref: loaderRef2 })] })) })));
};
exports.default = react_1.default.memo(RechargesTableBody);
